import { enrollmentEngagementService } from '@/data/services/enrollment/enrollment-engagement-service'
import { EnrollmentEngagementData } from '@/data/services/enrollment/enrollment-engagement-service-types'
import { ConflictError } from '@/domain/errors'

export async function loadUserEnrollmentEngagement(
  enrollmentId: string,
  request?: Request
): Promise<EnrollmentEngagementData | null> {
  const completedContent = request
    ? new URL(request.url).searchParams.get('completed_content') === 'true'
    : false
  try {
    return await enrollmentEngagementService.fetchEnrollmentEngagement(
      enrollmentId,
      completedContent || undefined
    )
  } catch (error) {
    if (error instanceof ConflictError) return null
    throw error
  }
}
